module.exports = __webpack_public_path__ + "static/media/angular.09af26ef.png";